import { RemoteLog } from '@/modules/common/utils/loggingUtils'

function logDocumentOpened(documentKind: string) {
	RemoteLog.usage({ message: 'Document opened', context: { document: documentKind } })
}

export function openDocument(documentKind: string, url: string | undefined) {
	logDocumentOpened(documentKind)
	window.open(url, '_blank')
}

// A link's path and query can carry the client's details, as the storefront checkout's do, so only its host.
function destinationOf(link: HTMLAnchorElement): string {
	return link.host === '' ? link.protocol.replace(':', '') : link.host
}

function logFollowedLink(event: MouseEvent) {
	const link = event.target instanceof Element ? event.target.closest('a[href]') : null

	if (!(link instanceof HTMLAnchorElement)) {
		return
	}

	if (link.dataset.document !== undefined) {
		logDocumentOpened(link.dataset.document)
		return
	}

	if (link.origin === window.location.origin) {
		return
	}

	RemoteLog.usage({
		message: 'Outbound link followed',
		context: { destination: destinationOf(link) },
	})
}

// On the document, not the app's root: Headless UI moves an open dialog, and its links, out under <body>.
export function registerLinkUsageLog() {
	document.addEventListener('click', logFollowedLink, { capture: true })
}
